import React, { useState, useEffect } from 'react';
import './GeneralAI.css';
import { TbScanEye, TbFingerprintScan  } from "react-icons/tb";
import { RiSwordFill } from "react-icons/ri";
import { BsGlobe } from "react-icons/bs";
import { IoSearchCircleSharp } from "react-icons/io5";
import { FaGoogle, FaFilm, FaArrowAltCircleLeft } from "react-icons/fa";
import { collection, query, where, orderBy, onSnapshot, addDoc, serverTimestamp, doc, getDocs, getDoc, setDoc, updateDoc, arrayUnion} from 'firebase/firestore';
import { db, auth } from '../../Firebase_Config/firebase';
import { NavLink } from "react-router-dom";





const toolsData = {
  IBMSkillsBuild: {
    title: 'IBM SkillsBuild – Artificial Intelligence.',
    content: [
      "You've probably heard about the artificial intelligence and machine learning algorithms that power your favorite apps with data science and deep learning techniques.",
      "But how much do you really know about how AI works or how it's changing the world around us?",
      "Learn the basics of this technology, which has the potential to change every single job in the near future, and start building your skills with these free courses."
    ],
    link: 'https://skillsbuild.org/students/course-catalog/artificial-intelligence',
    buttonText:'Start Learning',
    accentClass: 'card-accent'
  },
  googleAI: {
    title: 'Google AI Courses',
    content: [
      "Offers practical AI training and tools to help you build essential AI skills.",
      "AI is changing how we work, offering new ways to make decisions, solve problems, and be more productive and creative.",
      "Learn how to harness these benefits with practical AI training and tools from Grow with Google.",
    ],
    buttonText:'Start Learning',
    link: 'https://grow.google/ai/',
    accentClass: 'card-accent alt'
  },
   Video1: {
    title: `Introduction To Artificial Intelligence: What Is AI? `,   
    source: '/Videos/WhatIsAi.webm',
    accentClass: 'card-accent alt2',
    commentsDoc: 'comments_WhatIsAi'
  },
  Video2: {
    title: `Introduction To Generative AI `,   
    source: '/Videos/IntroductionToGenerativeAi.webm',
    accentClass: 'card-accent alt3',
    commentsDoc: 'comments_IntroductionToGenerativeAi'
  },
};
 const getUserId = () => {
      const user = auth.currentUser;
      return user.uid;
    };

  const CommentsSection = ({ commentsDoc }) => {
      const [comment, setComment] = useState("");
      const [comments, setComments] = useState([]);
      const [userName, setUserName] = useState("");
    
      useEffect(() => {
    
        const fetchSectorNameAndScores = async () => {
                try {
                    const userId = getUserId();
                    console.log('User ID:', userId); // Add this line for debugging     
                    const userDocQuery = query(collection(db, 'users'), where('userId', '==', userId));
                    const userDocSnapshot = await getDocs(userDocQuery);     
                    if (!userDocSnapshot.empty) {                      
                        const userDocData = userDocSnapshot.docs[0].data();                  
                        const UserName =userDocData.Name ||0;
                        setUserName(UserName)                        
                    } else {
                        console.log('User document not found for user ID:', userId);
                    }                  
                      } catch (error) {
                          console.error('Error fetching document:', error);
                      }
            };      
            fetchSectorNameAndScores();
  
            const commentsDocRef = doc(db,"comments", commentsDoc);
  
            const unsubscribe = onSnapshot(commentsDocRef, (docSnap) => {
              if (docSnap.exists()) {
                const data = docSnap.data();
                setComments(data.messages || []);
              } else {
                // If the document doesn't exist yet, create it
                setDoc(commentsDocRef, { messages: [] });
              }
            });
    
        return () => unsubscribe();
      }, []);
    
      const handlePostComment = async () => {
        const trimmed = comment.trim();
        if (!trimmed) return;
    
        const user = auth.currentUser;
        if (!user) return;
    
        const newComment = {
          text: trimmed,
          author: userName,
          uid: user.uid,
          timestamp: new Date().toISOString(),
        };
    
        const commentsDocRef = doc(db, "comments", commentsDoc );
    
        try {
          await updateDoc(commentsDocRef, {
            messages: arrayUnion(newComment),
          });
          setComment("");
        } catch (error) {
          console.error("Error posting comment:", error);
        }
      };
    
      return (
        <div style={{  margin: "auto" }}>
          <h2>Comments</h2>
          <div>
            <input
                    className="form_input"
                    type="text"
                    id="comment"
                    name="comment"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    placeholder="Add a comment..."
                  />
            <button className='full-width-button' onClick={handlePostComment} >
              Comment
            </button>
          </div>
          <div style={{ marginBottom: "1rem" }}>
            {comments
              .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
              .map((c, index) => (
                <div
                  key={index}
                  style={{ borderBottom: "1px solid #ccc", padding: "1rem 0" }}
                >
                  <strong>{c.author}</strong>
                  <p>{c.text}</p>
                  <div style={{ fontSize: "0.8em", color: "gray" }}>
                    {new Date(c.timestamp).toLocaleString()}
                  </div>
                </div>
              ))}
          </div>
          {/*<textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            rows={3}
            placeholder="Leave a comment..."
            style={{ width: "100%", padding: "0.5rem" }}
          />*/}
         
        </div>
      );
    };

    const RenderCard = ({selectedTool}) => {
      const tool = toolsData[selectedTool];

      if (selectedTool === 'Video1' || selectedTool === 'Video2') {
      return (
        <div className='Network-card'>
            <div className={tool.accentClass} />
            <div className="Netprofessional-card">
                <div className="card-body">
                <h2 className="card-title">{tool.title}</h2>
                <div className='trainPP'>
                    <video autoPlay controls key={tool.source}>
                    <source src={tool.source} type="video/webm" />
                    </video>
                </div>
                <CommentsSection commentsDoc={tool.commentsDoc} />
                </div>
            </div>
        </div>
      );
    }
      return (
        <div className='Network-card'>
          <div className={tool.accentClass} />
          <div className="Netprofessional-card">
            <div className="card-body">
              <h2 className="card-title">{tool.title}</h2>
              {tool.content.map((paragraph, idx) => (
                <p key={idx}>{paragraph}</p>
              ))}
              <a href={tool.link} target="_blank" rel="noopener noreferrer" className="full-width-button">
                {tool.buttonText}
              </a>
            </div>
          </div>
        </div>
      );
    };

const GeneralAI = () => { 
    const [selectedTool, setSelectedTool] = useState('IBMSkillsBuild');
  return (
    <div className='backgroundHelp'>
      <div className="InternetHyContent">
        <div className='bannerBG'>
          <img src="../banner.png" alt="banner2" className='banner-image' />
        </div>
        <h1 className="helptitle bigger">General AI Training</h1>
        <div className='BasicGrid'>
          <div className='BasicGrid2'>
            <NavLink to="/Support" >
              <button className="navButtons">
                <div>
                  <FaArrowAltCircleLeft className="helpicons" />
                </div>
                <span>Back</span>
              </button>
            </NavLink>
            <button className="navButtons" onClick={() => setSelectedTool('IBMSkillsBuild')}>
              <div>
                <BsGlobe className="helpicons" />
              </div>
              <span>IBM SkillsBuild</span>
            </button>
            <button className="navButtons" onClick={() => setSelectedTool('googleAI')}>
              <div>
                <FaGoogle className="helpicons" />
              </div>
              <span>Google AI Courses</span>
            </button>
            <button className="navButtons" onClick={() => setSelectedTool('Video1')}>
              <div>
                <FaFilm className="helpicons" />
              </div>
              <span>What Is AI?</span>
            </button>
            <button className="navButtons" onClick={() => setSelectedTool('Video2')}>
              <div>
                <FaFilm className="helpicons" />
              </div>
              <span>Introduction To Generative AI</span>
            </button>
          </div>      
        </div>
        <br/>
        <div className="help-hrLine" />
        <br/>
        <RenderCard selectedTool={selectedTool}/>  
      </div>
    </div>
  );
};

export default GeneralAI;
